import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';
import { deleteField, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { auth, db } from '../firebaseconfig';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Navbar } from './NavBar';

export function VoteJudge() {

    const location = useLocation()
    const navigate = useNavigate()

    const { user, loading, signOut } = useContext(AuthContext)

    const [judge, setJudge] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const [categorySelect, setCategorySelect] = useState(false)
    const [category, setCategory] = useState(null)
    const [participants, setParticipants] = useState([])
    const [currentParticipant, setCurrentParticipant] = useState(0)
    const [selectedPoint, setSelectedPoint] = useState(null)
    const [comment, setComment] = useState("")

    const numbers_1 = [1, 2, 3, 4, 5]
    const numbers_2 = [6, 7, 8, 9, 10]

    const checkCategory = async() => {

        // check if user is logged in
        if (user) {
            const judgeData = (await getDoc(doc(db, "judges", user.uid))).data()

            // check if judge has selected
            if (!judgeData.categorySelected) {
                // if no category is selected -> setCategorySelect to true
                setCategorySelect(true)
                setIsLoading(false)
            } else {
                // if category is selected -> fetch participants
                setCategory(judgeData.category)
                fetchParticipants(judgeData.category, judgeData.votes, judgeData[`category_${judgeData.category}_persistance`])
                .then(() => {
                    // setCategorySelect to false and setCurrentParticipant based on judge category persistance data
                    setCategorySelect(false)
                    setCurrentParticipant(judgeData[`category_${judgeData.category}_persistance`])
                    setIsLoading(false)
                })
            }
        }

    }

    useEffect(() => {

        // Set default back navigation to home page
        const handlePopState = (event) => {
            event.preventDefault()
            navigate("/", { replace: true })
        }

       window.addEventListener("popstate", handlePopState);

       // If user is still loading, return early to avoid bad rendering
        if (loading) {
            return
        }

        checkJudgeIntegrity()

        return () => {window.removeEventListener("popstate", handlePopState)}

    }, [navigate, loading, user])


    const checkJudgeIntegrity = async () => {

        // if user is logged in and if user is a judge
        if (user) {

            if ((await getDoc(doc(db, "judges", user.uid))).exists()) {
                setJudge(true)
                checkCategory()
            } else {
                setJudge(false)
                setIsLoading(false)
                return
            }
            
        } else {
            setIsLoading(false)
            return
        }

    }

    const fetchParticipants = async(category, judgeData, persistance) => {

        const docData = (await getDoc(doc(db, "candidates", category.toString()))).data()
        for (const key in docData) {
            // fetch candidate data from database -> if judgeData (judge votes) contains a candidate's ID ->
            // judge has voted for the candidate -> update their data accordingly
            // if judge has not voted a candidate (not found in judgeData) -> update to default parameters
            if (judgeData.hasOwnProperty(key)) {
                docData[key] = {points_given: judgeData[key].points_given, comment: judgeData[key].comment, ...docData[key]}
            } else {
                docData[key] = {points_given: null, comment: "", ...docData[key]}
            }

        }

        // set participants, selected point and comment for current candidate (given by persistance)
        setParticipants(docData)
        setSelectedPoint(docData[persistance].points_given)
        setComment(docData[persistance].comment)

    }


    async function handleClickNext() {

        // not more participants than list length
        if (currentParticipant + 1 === Object.keys(participants).length) {
            return
        }

        // show confirmation if judge wants to proceed without finalizing vote
        if (participants[currentParticipant].points_given === null) {

            if(!window.confirm("Nem véglegesítette szavazát!")) {
                return
            }

        }

        // update judge persistance
        const updateString = `category_${category}_persistance`

        await updateDoc(doc(db, "judges", user.uid), {
            [updateString]: currentParticipant + 1
        })

        // set data for new participant
        setSelectedPoint(participants[currentParticipant + 1].points_given)
        setComment(participants[currentParticipant + 1].comment)
        setCurrentParticipant(currentParticipant + 1)

    }

    async function handleClickPrevious() {
        
        // no negative index
        if (currentParticipant === 0) {
            return
        } else {

            // update judge persistance
            const updateString = `category_${category}_persistance`

            await updateDoc(doc(db, "judges", user.uid), {
                [updateString]: currentParticipant - 1
            })
            
            // set data for new participant
            setSelectedPoint(participants[currentParticipant - 1].points_given)
            setComment(participants[currentParticipant - 1].comment)
            setCurrentParticipant(currentParticipant - 1)

        }

    }

    async function handleCategorySelect (category) {

        // If the user selects the final round, show an alert and exit early
        if (category === 3) {
            alert("A döntőre való szavazás még nem elérhető!")
            return
        }

        // Persist the selected category for this judge in database
        await updateDoc(doc(db, "judges", user.uid), {
            category: category,
            categorySelected: true
        })

        checkCategory()

    }

    async function changeCategory() {

        // Clear the category and selection flag in database
        await updateDoc(doc(db, "judges", user.uid), {
            category: null,
            categorySelected: false,
        })

        // Reset all related local React state to initial values
        setParticipants([])
        setCategory(null)
        setCategorySelect(true)
        setCurrentParticipant(0)
        setSelectedPoint(null)
        setComment("")

    }
 
    async function handleClear() {
        
        // Delete the corresponding vote field for the judge in database
        const updateString = `votes.${currentParticipant}`

        await updateDoc(doc(db, "judges", user.uid), {

            [updateString]: deleteField()

        })

        // Reset all related local React state to initial values and point&comment participant data to initial values
        participants[currentParticipant].points_given = null
        participants[currentParticipant].comment = ""
        setParticipants(participants)
        setSelectedPoint(null)
        setComment("")

    }

    async function handleFinalize() {

        // set votes for current candidate
        const updateString = `votes.${currentParticipant}`

        await updateDoc(doc(db, "judges", user.uid), {
            [updateString]: {
                points_given: selectedPoint,
                comment: comment
            },
        })

        // update states for current candidate
        participants[currentParticipant].points_given = selectedPoint
        participants[currentParticipant].comment = comment
        setParticipants(participants)

    }

    // If data is still loading, show a loading indicator to the user to prevent bad rendering
    if (loading || isLoading) {
        return(<div>Betöltés... Kérem Várjon</div>)
    }

    return (

        user ? (

        judge ? (
 
             <>
 
             <div className='main-container'>
 
                 <Navbar text2="Kijelentkezés" onClick2={signOut}/>
 
                 {categorySelect ? (
                    <div className='vote-container'>
                        <h1>Kérem válasszon kategóriát!</h1>
                        <div key={1} className='category-container' onClick={() => handleCategorySelect(1)}>
                            <p>1. Kategória<br/>7-10. osztály</p>
                        </div>
                        <div key={2} className='category-container' onClick={() => handleCategorySelect(2)}>
                            <p>2. Kategória<br/>11-12. osztály</p>
                        </div>
                        <div key={3} className='category-container' onClick={() => handleCategorySelect(3)}>
                            <p>2.Döntő<br/>Minden évfolyam</p>
                        </div>
                    </div>) : (
                    <div className='vote-container'>
                        <h1 className='judge-vote-main-title'>Üdvözöljük az értékelési felületen!</h1>
                        <h3 className='judge-vote-secondary-title'>Kérem válasszon 1-10-ig egy értékelést minden résztvevőnek!</h3>

                        <button className='change-category-button' onClick={changeCategory}>Kategória megváltoztatása</button>

                        <div className='candidate-container'>

                            <div className='candidate-name-container'>
                                <p>{participants[currentParticipant].name}</p>
                            </div>

                            <div className='candidate-points-container'>
                                <div className='points-tofive-container'>

                                    {numbers_1.map(number => (
                                    
                                        <div key={number} 
                                        className={`number-item ${selectedPoint === number ? 'selected' : ''}`}
                                        onClick={() => setSelectedPoint(number)}>
                                            <p>{number}</p>
                                        </div>

                                    ))}

                                </div>
                                <div className='points-fromfive-container'>

                                    {numbers_2.map(number => (
                                        
                                        <div key={number} 
                                        className={`number-item ${selectedPoint === number ? 'selected' : ''}`}
                                        onClick={() => setSelectedPoint(number)}>
                                            <p>{number}</p>
                                        </div>

                                    ))}

                                </div>
                            </div>

                            <div className='comment-container'>
                                <label for='comment-text-area'>Megjegyzés:</label>
                                <textarea id="comment-text-area" value={comment} onChange={e => setComment(e.target.value)} lang='hu' spellCheck={false}/>
                            </div>

                            <button className='clear-button' onClick={handleClear}>Törlés</button>

                        </div>

                        <button className='finalize-button' onClick={handleFinalize}>Véglegesít</button>
                            
                        <div className='button-container'>
                            <button className='previous-button' onClick={handleClickPrevious}></button>
                            <button className='next-button' onClick={handleClickNext}></button>
                        </div>
                
                    </div>)}
                
            </div>
 
            </>
 
         ) : (
            <Navigate to="/login-judge" state={{ from: location.pathname, message: "Jelentkezzen be a szavazáshoz megfelelő zsűri fiókkal!" }}/>
        )
        ) : (
            <Navigate to="/login-judge"/>
        )
     );
 
}
